import { createSlice } from "@reduxjs/toolkit"
//import axios from 'axios';


const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("Class") !== null && localStorage.getItem("Class") !== undefined && localStorage.getItem("Class") !== "") {

    data = [JSON.parse(localStorage.getItem("Class"))]

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {

        getdata_: (state, action) => {

            return action.payload.data || [];

        },

        logout_: (state, action) => {


            localStorage.clear()
            state = []


        },

        updateclassdata: (state, action) => {


            return action.payload.data || [];

        },


    }
})

export const { logout_, updateclassdata, login, getdata_ } = Insider.actions;
export default Insider.reducer;